import React from 'react';
import { useLocation } from 'react-router-dom';
import { captureReferralFromSearch, getPendingCampaignSlug } from '../../lib/referralAttribution';
import { ambassadorOsService } from '../../services/ambassadorOsService';
import { impactService } from '../../services/impactService';

/** Stores ?ref= / ?camp= from any route so signup can attribute the referral later. */
export function ReferralCapture() {
  const location = useLocation();
  React.useEffect(() => {
    const ref = captureReferralFromSearch(location.search);
    if (ref) {
      void ambassadorOsService.recordClick(ref, location.pathname);
    }
    const camp = getPendingCampaignSlug();
    if (camp) {
      void impactService.recordCampaignEvent(camp, 'click');
    }
  }, [location.search, location.pathname]);
  return null;
}